import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M28.75 38.75c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M25.625 26.875A3.125 3.125 0 1 1 28.75 30M28.75 33.75a.625.625 0 1 1 0 1.25.625.625 0 0 1 0-1.25M13.75 33.75h-10a2.5 2.5 0 0 1-2.5-2.5V3.75a2.5 2.5 0 0 1 2.5-2.5h17.715a2.5 2.5 0 0 1 1.767.732l4.786 4.786a2.5 2.5 0 0 1 .732 1.767v5.215"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M8.75 9.375a.625.625 0 1 1 0 1.25.625.625 0 0 1 0-1.25M20.142 15.976 18.75 13.75a1.248 1.248 0 0 0-2.063-.024l-3.334 4.752-2.053-1.645a1.25 1.25 0 0 0-1.822.282L6.25 23.75h7.5"
    }, null, -1)
  ]))]))
}
export default { render: render }